import i18n from '@/utils/i18n';
import React from 'react';
import {
  Delta,
  MetricCard,
  Surface,
  Typography,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { MANAGER_FORECAST_WINDOWS_IN_DAYS } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { ManagerSectionError } from '@/experiences/sales-portal/domain/prospects/screens/prospects/components/prospects-manager-view/manager-section-error';
import type { ManagerForecastTileData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

interface ProspectsManagerForecastTilesProps {
  hasError: boolean;
  isLoading: boolean;
  onRetry: () => void;
  tiles: ManagerForecastTileData[];
}

export const ProspectsManagerForecastTiles: React.FC<
  ProspectsManagerForecastTilesProps
> = ({ hasError, isLoading, onRetry, tiles }) => {
  if (hasError) {
    return (
      <Surface>
        <YStack gap="$8" padding="$16">
          <Typography size="$sm" variant="label">
            {i18n.t('sales_portal.prospects.manager.forecast.closing_windows', {
              windows: MANAGER_FORECAST_WINDOWS_IN_DAYS.join(' / '),
            })}
          </Typography>

          <ManagerSectionError onRetry={onRetry} />
        </YStack>
      </Surface>
    );
  }

  return (
    <MetricCard.Group dividers isLoading={isLoading}>
      {tiles.map((tile) => (
        <MetricCard
          key={tile.id}
          label={tile.label}
          value={tile.totalValueDisplay}
        >
          <MetricCard.Footer>
            <Delta direction="flat" value={tile.prospectCountDisplay} />
          </MetricCard.Footer>
        </MetricCard>
      ))}
    </MetricCard.Group>
  );
};
